import {} from 'enums/partnerships';
import { isPartnershipMemberAccessNone } from 'helpers/partnershipMembers';
export const getIconColorForAccess = (access) => {
    if (isPartnershipMemberAccessNone(access)) {
        return 'var(--color-grey50)';
    }
    return 'var(--color-green60)';
};
